<div class="s09">
  <div class="s09-grad"></div>
  <div class="s09-body" [class.canvas-mode]="view==='canvas'">

    <!-- Landing: one header with the section tabs -->
    <header class="s09-top" *ngIf="view==='list' && !lifecycleEditing">
      <span class="s09-title">Workflow Designer</span>
      <nav class="s09-edit-tabs s09-tabs-inline" aria-label="Landing sections">
      <button
        type="button"
        class="s09-shell-tab"
        [class.active]="landTab==='caseflow'"
        (click)="setLandTab('caseflow')">
        Case lifecycles
        <span class="s09-tab-count">{{ lifecycleCount }}</span>
      </button>
      <button
        type="button"
        class="s09-shell-tab"
        [class.active]="landTab==='automation'"
        (click)="setLandTab('automation')">
        Automations
        <span class="s09-tab-count">{{ definitions.length }}</span>
      </button>
      <button
        *ngIf="landTab==='caseflow'"
        type="button"
        class="s09-btn-create s09-land-new"
        (click)="newLifecycle()">
        New Case Lifecycle
      </button>
      </nav>
    </header>

    <!-- Edit: one header — name, tabs, and canvas controls -->
    <header class="s09-top s09-top-edit" *ngIf="view==='canvas' && currentDef">
      <div class="s09-top-left">
        <button type="button" class="s09-back" (click)="backToList()" title="Back to workflow list">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5M11 18l-6-6 6-6"></path></svg>
        </button>
        <div class="s09-edit-name">
          <input
            class="s09-edit-name-input"
            [ngModel]="draftName"
            (ngModelChange)="onDraftName($event)"
            placeholder="Workflow name" />
          <span class="s09-chip">v{{ currentDef.version || 1 }}</span>
          <span
            class="s09-chip"
            [class.status-draft]="(currentDef.status||'DRAFT')!=='ACTIVE'"
            [class.status-active]="currentDef.status==='ACTIVE'">
            {{ currentDef.status || 'DRAFT' }}
          </span>
        </div>
        <nav class="s09-edit-tabs s09-tabs-inline" aria-label="Edit workflow sections">
          <button type="button" class="s09-shell-tab" [class.active]="shellTab==='workflows'" (click)="setShellTab('workflows')">Workflow</button>
          <button type="button" class="s09-shell-tab" [class.active]="shellTab==='templates'" (click)="setShellTab('templates')">Templates</button>
          <button type="button" class="s09-shell-tab" [class.active]="shellTab==='signals'" (click)="setShellTab('signals')">Signals</button>
        </nav>
      </div>
      <div class="s09-tab-actions" *ngIf="shellTab==='workflows' && wfDesigner">
        <button type="button" class="s09-btn" [class.on]="wfDesigner.libOpen" (click)="wfDesigner.libOpen ? wfDesigner.closeLibrary() : wfDesigner.openLibrary()">
          {{ wfDesigner.libOpen ? 'Hide steps' : 'Add step' }}
        </button>
        <button type="button" class="s09-btn" (click)="wfDesigner.addCanvasAttempt()">Add attempt</button>
        <button type="button" class="s09-btn" (click)="wfDesigner.openTrigger()">Trigger</button>
        <button type="button" class="s09-btn" [disabled]="!wfDesigner.canUndo" title="Undo (Ctrl+Z)" (click)="wfDesigner.undo()">Undo</button>
        <button type="button" class="s09-btn" [disabled]="!wfDesigner.canRedo" title="Redo (Ctrl+Y)" (click)="wfDesigner.redo()">Redo</button>
        <button type="button" class="s09-btn" [disabled]="!wfDesigner.canCopyStep" title="Copy selected step (Ctrl+C)" (click)="wfDesigner.copySelected()">Copy</button>
        <button type="button" class="s09-btn" [disabled]="!wfDesigner.canPasteStep" title="Paste step (Ctrl+V)" (click)="wfDesigner.pasteStep()">Paste</button>
        <button type="button" class="s09-btn danger-text" [disabled]="!wfDesigner.canDeleteStep" title="Delete selected step" (click)="wfDesigner.removeSelected()">Delete</button>
        <button type="button" class="s09-btn s09-val-toggle" [class.on]="wfDesigner.valOpen && !wfDesigner.hasInspector" (click)="wfDesigner.toggleValidation()">
          Validation
          <span class="s09-val-dot" [class.ok]="wfDesigner.valBadge.ok" [class.bad]="!wfDesigner.valBadge.ok"></span>
        </button>
        <button type="button" class="s09-btn" title="Stack nodes vertically" (click)="wfDesigner.autoArrange()">Arrange</button>
        <button type="button" class="s09-btn primary" [disabled]="saving" (click)="saveCanvas()">{{ saving ? 'Saving…' : (saveState === 'saved' ? 'Saved' : 'Save') }}</button>
        <button type="button" class="s09-btn" [disabled]="saving" (click)="openRun()">Run</button>
        <button *ngIf="(currentDef.status || 'DRAFT') !== 'ACTIVE'" type="button" class="s09-btn active-green" (click)="activate()">Activate</button>
        <button *ngIf="currentDef.status === 'ACTIVE'" type="button" class="s09-btn" (click)="pause()">Pause</button>
      </div>
    </header>

    <div class="s09-main s09-main-panel" [class.s09-lc-host]="lifecycleEditing" *ngIf="view==='list' && landTab==='caseflow'">
      <app-s09-case-flow
        [brandKey]="brandKey"
        [newToken]="newLifecycleToken"
        (countChange)="lifecycleCount=$event"
        (editingChange)="lifecycleEditing=$event">
      </app-s09-case-flow>
    </div>

    <!-- Landing / Automation list -->
    <div class="s09-main" *ngIf="view==='list' && landTab==='automation'" style="position:relative">
      <app-s09-workflow-list
        [definitions]="definitions"
        [designMetaById]="designMetaById"
        [loading]="loading"
        (create)="openCreate()"
        (cloneWorkflow)="openClone($event)"
        (openWorkflow)="openDef($event)"
        (deleteWorkflow)="deleteDef($event)"
        (showLogs)="openLogs($event)">
      </app-s09-workflow-list>

      <div class="s09-logs" *ngIf="logsOpen">
        <div style="display:flex;align-items:center;justify-content:space-between;gap:12px">
          <h4>Run logs — {{ logsTitle }}</h4>
          <button type="button" class="s09-btn" (click)="logsOpen=false">Close</button>
        </div>
        <div *ngIf="!logRuns.length" style="font-size:12px;color:var(--s09-muted);padding:8px 0">No runs yet.</div>
        <div class="s09-log-row" *ngFor="let r of logRuns">
          <span>{{ r.status }}</span>
          <span>{{ r.trigger_type || '—' }}</span>
          <span>{{ r.started_time | date:'short' }} · run #{{ r.wf_run_id }}</span>
        </div>
        <div *ngIf="logSteps.length" style="margin-top:12px">
          <h4>Latest run steps</h4>
          <div class="s09-log-row" *ngFor="let s of logSteps">
            <span>{{ s.status }}</span>
            <span>{{ s.step_type_id || s.step_key }}</span>
            <span>{{ s.error_message || s.output_context || '—' }}</span>
          </div>
        </div>
      </div>

      <app-s09-create-dialog
        *ngIf="showCreate"
        [brandName]="brandName"
        [brandKey]="brandKey"
        [definitions]="definitions"
        [sourceId]="cloneSourceId"
        (close)="showCreate=false; cloneSourceId=null"
        (create)="onCreate($event)">
      </app-s09-create-dialog>
    </div>

    <div class="s09-main s09-main-panel" *ngIf="view==='canvas' && shellTab==='templates'">
      <app-s09-templates [brandKey]="brandKey"></app-s09-templates>
    </div>

    <div class="s09-main s09-main-panel" *ngIf="view==='canvas' && shellTab==='signals'">
      <app-s09-entry-signals [brandKey]="brandKey"></app-s09-entry-signals>
    </div>

    <app-s09-workflow-designer
      *ngIf="view==='canvas' && doc && currentDef"
      [hidden]="shellTab!=='workflows'"
      [doc]="doc"
      [wfName]="draftName"
      [status]="currentDef.status || 'DRAFT'"
      [version]="currentDef.version || 1"
      [brandKey]="brandKey"
      [toast]="toast"
      [saving]="saving"
      [hideNameBar]="true"
      (docChange)="onDocChange($event)"
      (nameChange)="onDraftName($event)"
      (back)="backToList()"
      (save)="saveCanvas()"
      (activate)="activate()"
      (pause)="pause()">
    </app-s09-workflow-designer>

    <app-s09-workflow-run
      *ngIf="view==='run' && currentDef"
      [wfDefId]="currentDef.wf_def_id"
      [brandKey]="brandKey"
      [workflowStatus]="currentDef.status || 'DRAFT'"
      [initiatedBy]="userName"
      (back)="view='canvas'">
    </app-s09-workflow-run>
  </div>
</div>
